<template>
  <div class="flex items-center gap-2 px-2 py-3">
    <span class="text-sm">ANPR</span>
    <span
      class="text-sm font-medium"
      :class="camera.anprEnabled ? 'text-primary' : 'text-background-fg/40'"
    >
      {{ camera.anprEnabled ? "ON" : "OFF" }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { type Camera } from "@/services/cameras/listCameras";

// Read-only ANPR status for now (toggling lives in CameraAnprControlItem).
defineProps<{ camera: Camera }>();
</script>
